export const screenBreakPoints = [
    { name: 'small', min: 1, max: 425, columns: 1 },
    { name: 'medium', min: 426, max: 700, columns: 2 },
    { name: 'large', min: 701, max: 1000, columns: 3 },
    { name: 'extraLarge', min: 1001, max: 1250, columns: 4 }
];
